import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32
}

/**
 * Stateless function representing a search icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <SearchIcon width={12} />
 */
const SearchIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M14 4c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10
            4.486-10 10-10zM14 1.333c-6.995 0-12.667 5.671-12.667 12.667s5.671
            12.667 12.667 12.667 12.667-5.671 12.667-12.667-5.671-12.667-12.667-12.667v0z`}
        />
        <path
            d={`M25.92 23.091c-1.208 0.631-2.197 1.62-2.828 2.828l4.161 4.161c0.391
            0.39 0.902 0.586 1.414 0.586s1.024-0.195 1.414-0.586c0.781-0.781 0.781-2.047 0-2.828l-4.162-4.161z`}
        />
    </SvgIcon>
)

SearchIcon.defaultProps = defaultProps

export { SearchIcon }
